import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useMemo,
} from "react";
import PropTypes from "prop-types";

import axios from "axios";
import Cookies from "js-cookie";
import loadable from "@loadable/component";
import { CartContext } from "components/cart";
import { API_GATEWAY_NEW } from "aws-exports";
import API from "../Api";
import useCampaign from "hooks/useCampaign";
import classNames from "lib/classNames";
import { GetCartLevelAutoDiscount } from "../Utils";
import { DefaultAutoDiscountSettings } from "./CartItemsList";
const AddToUnlock = loadable(() => import("./AddToUnlock"));
const OneCheckUpSell = loadable(() => import("./OneCheckUpSell"));
const Scary = loadable(() => import("./scary"));
const Badges = loadable(() => import("./badges"));
const Announcement = loadable(() => import("./announcement"));
const AfterPay = loadable(() => import("./afterPay"));
const NewOneCheckUpSell = loadable(() => import("./NewOneCheckUpSell"));
const ConditionCheck = loadable(() => import("./ConditionCheck"));
const CouponCodeForm = loadable(() => import("./CouponCodeForm"));

const CheckoutButton = (props) => {
  const {
    campaigns,
    cart_settings,
    get_total,
    Utils,
    isPreview,
    shop_url,
    cart_level_discount_applications,
    shopify_cart_items,
    shopify_cart_upsells,
    cart_currency,
    productAddedToCart,
    discountCode,
    token,
    showCheckoutLoading,
    cartNote,
    slider,
    setPreviewed_product,
    update_cart_item,
    hasAutoDiscount,
    rechargeSettings,
  } = useContext(CartContext);
  const cartLevelAutoDiscount = useMemo(() => {
    return GetCartLevelAutoDiscount({ cart_level_discount_applications });
  }, [shopify_cart_items, cart_level_discount_applications]);
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [previewCheckoutToast, setPreviewCheckoutToast] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [shakeClass, setShakeClass] = useState("");
  const {
    theme: { secondary, primary, background },
    money_format,
    modules: { checkout_button },
    auto_discount = DefaultAutoDiscountSettings,
    currency,
    show_coupon,
    show_coupon_alert_text,
    rtl,
    cod_settings = {},
    scary = {},
    badges = {},
    announcement = {},
    afterPay,
    checkout_condition_text,
    is_checkout_condition_active,
    checkout_condition_color,
  } = cart_settings;
  function formatAutoDiscount(discount) {
    const { title, total_allocated_amount } = discount;
    return auto_discount.text.text
      .replace("{{title}}", title)
      .replace(
        "{{amount}}",
        Utils.formatMoney(total_allocated_amount, money_format)
      );
  }
  function formatCheckout(text) {
    const moneyHtml = Utils.formatMoney(get_total("subtotal"), money_format);
    const parser = new DOMParser();
    const doc = parser.parseFromString(moneyHtml, "text/html");
    const subtotal = doc.body.textContent || "";
    return text
      .replace(/\//g, "•")
      .replace(
        /(\{)?\{\s*subtotal\s*\}(\})?/gi,
        () => `<span class="money">${subtotal}</span>`
      );
  }
  const generateCheckoutUrl = (discount = null, esid = null) => {
    const wheelioDiscount = Cookies.get("discount_code");
    const queryString = [
      discount && `discount=${encodeURIComponent(discount)}`,
      !discount &&
        wheelioDiscount &&
        `discount=${encodeURIComponent(wheelioDiscount)}`,
      esid && `attributes[esid]=${esid}`,
    ].filter(Boolean);
    return Utils.getLangPath(
      `checkout${queryString.length ? `?${queryString.join("&")}` : ""}`
    );
    // return `https://${shop_url}/cart/${shopify_cart_items
    // 	.map(({ variant_id, quantity }) => `${variant_id}:${quantity}`)
    // 	.join()}${discount ? '?discount=' + discount : ''}`;
  };
  const setNote = async () => {
    try {
      await API.post(Utils.getLangPath("cart/update.js"), { note: cartNote });
    } catch (error) {
      console.log(error);
    }
  };
  const [one_check_up_sell_product_id, ocu_campaign, ocu_isGlobal] =
    useCampaign("one_check_up_sell", null, true)(campaigns, shopify_cart_items);
  const [add_to_unlock_product_id, add_to_unlock, isGlobal] = useCampaign(
    "add_to_unlock"
  )(campaigns, shopify_cart_items);
  const CAN_RENDER_ADD_TO_UNLOCK =
    add_to_unlock &&
    (add_to_unlock.products.length ||
      add_to_unlock.recommendation_type == "shopify_recommendation" ||
      isPreview) &&
    add_to_unlock.show_suggestions &&
    (productAddedToCart({ id: add_to_unlock_product_id }) ||
      (isGlobal && shopify_cart_items.length));
  const products = getAllOCUProducts(ocu_campaign);
  const CAN_RENDER_ONE_CHECK_UP_SELL =
    ocuHasProduct(ocu_campaign || {}, products, isPreview) &&
    (productAddedToCart({ id: one_check_up_sell_product_id }) ||
      (ocu_isGlobal && shopify_cart_items.length));

    const redirectToCheckout = async (discount = null, esid = null) => {
        if(window.addShipProtect){
            await window.addShipProtect();
        }
        const checkoutUrl = generateCheckoutUrl(discount, esid);
        if (window.mu_checkoutHook) {
            const response = await window.mu_checkoutHook(checkoutUrl, setCheckoutLoading);
            if(response) return;
        }
        setCheckoutLoading(false);
        window.location.href = checkoutUrl;
    };

  const generateReChargeCheckout = async () => {
    const {
      data: { token },
    } = await axios.get(`${window.location.origin}/cart.js`);
    const checkoutUrl = `https://checkout.rechargeapps.com/r/checkout?myshopify_domain=${
      shop_url || window.Shopify.shop
    }&cart_token=${token}`;
    setCheckoutLoading(false);
    window.location.href = checkoutUrl;
  };

    const checkout = async () => {
        const isRechargeCheckout =
            rechargeSettings &&
            !!shopify_cart_items.filter(
                ({ properties }) =>
                    properties &&
                    properties?.shipping_interval_frequency &&
                    properties?.shipping_interval_unit_type
            ).length;
        if (is_checkout_condition_active && !isTermsAccepted) {
            setShakeClass('shake-it');
            if (!shakeClass) {
                setTimeout(() => {
                    setShakeClass('');
                }, 900);
            }
            return;
        }
        if (isPreview) {
            setCheckoutLoading(true);
            setPreviewCheckoutToast(true);
            setTimeout(() => {
                setCheckoutLoading(false);
                setPreviewCheckoutToast(false);
            }, 4000);
            return;
        }
        await setNote();
        if (window.mu_custom_checkout) {
            const continueExecuting = await window.mu_custom_checkout();
            if(continueExecuting === false) return;
        }
        if (window.ttq && !window.mu_disable_tiktok_tracking) {
            window.ttq.track('StartCheckout', {
                value: get_total('subtotal') / 100,
                currency: cart_currency,
                contents: shopify_cart_items.map((item) => ({
                    content_type: 'product',
                    content_name: item.title,
                    content_id: item.product_id,
                    quantity: item.quantity,
                    price: item.price / 100
                }))
            });
        }
        setCheckoutLoading(true);
        if (discountCode) {
            return await redirectToCheckout(discountCode.code);
        } else if (hasAutoDiscount) {
            return await redirectToCheckout();
        }
        if (isRechargeCheckout) {
            return generateReChargeCheckout();
        }
        // const token = cart_token || generateToken(campaigns)
        API.post(`${API_GATEWAY_NEW}/public/checkout`, {
            shop: shop_url || window.Shopify?.shop,
            items: shopify_cart_items.map(
                ({ variant_id, product_id, quantity, selling_plan_allocation }) => ({
                    variant_id,
                    product_id,
                    quantity,
                    sp: selling_plan_allocation?.selling_plan?.id
                })
            ),
            note: cartNote,
            fbt: shopify_cart_upsells,
            cart_currency,
            schema: Object.entries(campaigns).reduce((acc, cur) => {
                const [product_id, campaigns] = cur;
                acc[product_id] = campaigns.map(({ campaign_key }) => campaign_key);
                return acc;
            }, {}),
            discountCode: discountCode?.title || null
        })
            .then(async ({ data: { invoice_url, code, esid } }) => {
                Cookies.remove('monster_cart');
                Cookies.remove('monster_product_id');
                if(!window.mu_keep_checkout_loading) setCheckoutLoading(false);
                if (invoice_url) {
                    window.location.href = invoice_url;
                } else {
                    if (code) {
                        await axios.get(`${window.location.origin}/discount/${code}`);
                    }
                    return await redirectToCheckout(code, esid);
                }
            })
            .catch((error) => {
                console.log('checkout error', error);
                setCheckoutLoading(false);
            });
    };

    useEffect(() => {
      async function getCheckoutInfo(
        items = window.mu_filter_discount_items
          ? window.mu_filter_discount_items(shopify_cart_items)
          : shopify_cart_items
      ) {
        const { data } = await API.post(`${API_GATEWAY_NEW}/public/checkout`, {
          shop: shop_url || window.Shopify?.shop,
          items: items.map(
            ({
              variant_id,
              product_id,
              quantity,
              selling_plan_allocation,
              price,
            }) => ({
              variant_id,
              product_id,
              quantity,
              sp: selling_plan_allocation?.selling_plan?.id,
              ...(selling_plan_allocation
                ? {
                    selling_plan: {
                      price_adjustments_value:
                        ((price - selling_plan_allocation.price) / price) * 100,
                      price_adjustments_value_type: "percentage",
                    },
                  }
                : {}),
            })
          ),
          note: cartNote,
          fbt: shopify_cart_upsells,
          cart_currency,
          schema: Object.entries(campaigns).reduce((acc, cur) => {
            const [product_id, campaigns] = cur;
            acc[product_id] = campaigns.map(({ campaign_key }) => campaign_key);
            return acc;
          }, {}),
          discountCode: discountCode?.title || null,
        });
        return data;
      }
      window.mu_get_discount = getCheckoutInfo;
    }, [
      discountCode,
      shopify_cart_items,
      cartNote,
      shopify_cart_upsells,
      campaigns,
    ]);
    
    useEffect(() => {
        window.mu_terms_accepted = isTermsAccepted;
    }, [isTermsAccepted]);

    return (
      <div
        id="mu-checkout-container"
        className={classNames("px-5", {
          "relative overflow-hidden border-t border-gray-300 pt-2 pb-2":
            checkout_button.fix_checkout_container,
        })}
      >
        {/* {isPreview && previewCheckoutToast && (
  const checkout = async () => {
    const isRechargeCheckout =
      rechargeSettings &&
      !!shopify_cart_items.filter(
        ({ properties }) =>
          properties &&
          properties?.shipping_interval_frequency &&
          properties?.shipping_interval_unit_type
      ).length;
    if (is_checkout_condition_active && !isTermsAccepted) {
      setShakeClass("shake-it");
      if (!shakeClass) {
        setTimeout(() => {
          setShakeClass("");
        }, 900);
      }
      return;
    }
    if (isPreview) {
      setCheckoutLoading(true);
      setPreviewCheckoutToast(true);
      setTimeout(() => {
        setCheckoutLoading(false);
        setPreviewCheckoutToast(false);
      }, 4000);
      return;
    }
    await setNote();
    if (window.ttq && !window.mu_disable_tiktok_tracking) {
      window.ttq.track("StartCheckout", {
        value: get_total("subtotal") / 100,
        currency: cart_currency,
        contents: shopify_cart_items.map((item) => ({
          content_type: "product",
          content_name: item.title,
          content_id: item.product_id,
          quantity: item.quantity,
          price: item.price / 100,
        })),
      });
    }
    setCheckoutLoading(true);
    if (discountCode) {
      return await redirectToCheckout(discountCode.code);
    } else if (hasAutoDiscount) {
      return await redirectToCheckout();
    }
    if (isRechargeCheckout) {
      return generateReChargeCheckout();
    }
    // const token = cart_token || generateToken(campaigns)
    API.post(`${API_GATEWAY_NEW}/public/checkout`, {
      shop: shop_url || window.Shopify?.shop,
      items: shopify_cart_items.map(
        ({ variant_id, product_id, quantity, selling_plan_allocation }) => ({
          variant_id,
          product_id,
          quantity,
          sp: selling_plan_allocation?.selling_plan?.id,
        })
      ),
      note: cartNote,
      fbt: shopify_cart_upsells,
      cart_currency,
      schema: Object.entries(campaigns).reduce((acc, cur) => {
        const [product_id, campaigns] = cur;
        acc[product_id] = campaigns.map(({ campaign_key }) => campaign_key);
        return acc;
      }, {}),
      discountCode: discountCode?.title || null,
    })
      .then(async ({ data: { invoice_url, code, esid } }) => {
        Cookies.remove("monster_cart");
        Cookies.remove("monster_product_id");
        if (!window.mu_keep_checkout_loading) setCheckoutLoading(false);
        if (invoice_url) {
          window.location.href = invoice_url;
        } else {
          if (code) {
            await axios.get(`${window.location.origin}/discount/${code}`);
          }
          return await redirectToCheckout(code, esid);
        }
      })
      .catch((error) => {
        console.log("checkout error", error);
        setCheckoutLoading(false);
      });
  };
  return (
    <div
      id="mu-checkout-container"
      className={classNames("px-5", {
        "relative overflow-hidden border-t border-gray-300 pt-2 pb-2":
          checkout_button.fix_checkout_container,
      })}
    >
      {/* {isPreview && previewCheckoutToast && (
				<Toast content={`This is only a preview button. Visit store for action`} duration={3000} />
			)} */}

        {cartLevelAutoDiscount && (
          <div style={{ textAlign: "end" }}>
            <div
              className={classNames(
                "text-sm p-1 rounded mb-1 inline-flex items-center space-x-1"
              )}
              style={{
                fontSize: `${auto_discount.text.font_size}em`,
                fontWeight: auto_discount.text.font_weight,
                color: Utils.formatColor(auto_discount.text.color),
                background: Utils.formatColor(auto_discount.background),
                border: `${Utils.formatColor(auto_discount.border)} 1px solid`,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                className={classNames("w-5 h-5")}
              >
                <path
                  fill-rule="evenodd"
                  d="M5.5 3A2.5 2.5 0 003 5.5v2.879a2.5 2.5 0 00.732 1.767l6.5 6.5a2.5 2.5 0 003.536 0l2.878-2.878a2.5 2.5 0 000-3.536l-6.5-6.5A2.5 2.5 0 008.38 3H5.5zM6 7a1 1 0 100-2 1 1 0 000 2z"
                  clip-rule="evenodd"
                />
              </svg>
              <span className={classNames("leading-none")}>
                {formatAutoDiscount(cartLevelAutoDiscount)}
              </span>
            </div>
          </div>
        )}
        {show_coupon && <CouponCodeForm />}

        {scary.isActive && scary.placement === "bottom" && (
          <Scary scary={scary} />
        )}
        {announcement?.isActive && announcement.position === "above_totals" && (
          <Announcement announcement={announcement} />
        )}
        {badges?.isActive && badges.position === "above_totals" && (
          <Badges badges={badges} />
        )}
        <InfoItem
          name={{ ...checkout_button.savings, text: "total" }}
          value={get_total("total")}
          infoClass="total hidden"
        />
        {get_total("finalDiscount") > 0 && (
          <InfoItem
            negative={true}
            name={checkout_button.savings}
            value={get_total("finalDiscount")}
            infoClass="savings"
          />
        )}

        <InfoItem
          name={checkout_button.subtotal}
          value={get_total("subtotal")}
          infoClass={`subtotal${
            checkout_button.show_subtotal ? " hidden" : ""
          }`}
        />
        {afterPay?.isActive && (
          <AfterPay afterPay={afterPay} price={get_total("subtotal")} />
        )}
        {!!CAN_RENDER_ONE_CHECK_UP_SELL && (
          <div
            id="mu-ocu-container"
            className={classNames("flex flex-col mb-1 space-y-1")}
          >
            {products.map((ocu, i) => {
              const isOld = !ocu_campaign?.multi_one_check_upsell;
              if (isOld) {
                return (
                  <OneCheckUpSell
                    key={`one_tick_${i}`}
                    one_check_up_sell={ocu}
                  />
                );
              } else {
                return (
                  <NewOneCheckUpSell
                    key={`one_tick_${i}`}
                    index={i}
                    one_check_up_sell={ocu}
                    multi_one_check_upsell={ocu_campaign.multi_one_check_upsell}
                  />
                );
              }
            })}
          </div>
        )}
        {!!is_checkout_condition_active && (
          <ConditionCheck
            {...{
              checkout_condition_text,
              checkout_condition_color,
              isTermsAccepted,
              setIsTermsAccepted,
              Utils,
              rtl,
              shakeClass,
            }}
          />
        )}
        {badges?.isActive && badges.position === "above_checkout" && (
          <Badges badges={badges} />
        )}
        <div className="fondue-cashback-module"></div>
        {/* normal checkout */}
        <button
          id="mu-checkout-button"
          className={classNames(
            `custom-btn w-full${checkout_button.checkout_as_link ? " py-1":" py-3"} mb-2 checkout-btn flex items-center justify-center`,
            {
              "rounded": !checkout_button.checkout_as_link,
              "hover:bg-transparent": checkout_button.checkout_as_link
            }
          )}
          style={{
            backgroundColor: checkout_button.checkout_as_link
              ? "transparent"
              : Utils.formatColor(checkout_button.background),
            border: checkout_button.checkout_as_link ? "none" : "inherit",
            textDecoration: checkout_button.checkout_as_link
              ? "underline"
              : "none",
            fontFamily: "inherit",
            fontSize: Utils.em(checkout_button.button_text.font_size),
            fontWeight: checkout_button.button_text.font_weight,
            color:
              checkoutLoading || showCheckoutLoading
                ? Utils.formatColor(checkout_button.button_text_loading.color)
                : Utils.formatColor(checkout_button.button_text.color),
            "--hover-background": Utils.formatColor(
              checkout_button.hoverBackground
            ),
          }}
          onClick={async () => await checkout()}
          disabled={checkoutLoading || showCheckoutLoading}
          data-loading={`${checkoutLoading || showCheckoutLoading}`}
          data-display={Utils.formatMoney(get_total("subtotal"), money_format)}
        >
          {window.mu_checkout_img && (
            <span
              className={classNames("mr-2")}
              dangerouslySetInnerHTML={{ __html: window.mu_checkout_img }}
            />
          )}
          <span
            dangerouslySetInnerHTML={{
              __html:
                (checkoutLoading || showCheckoutLoading) &&
                !window.mu_stop_checkout_loading
                  ? checkout_button.button_text_loading.text
                  : formatCheckout(checkout_button.button_text.text),
            }}
          />
          {/* {checkout_button.show_subtotal &&
          !checkoutLoading &&
          !showCheckoutLoading && (
            <span
              className={classNames("checkout-subtotal", {
                "ml-1": !rtl,
                "mr-1": rtl,
              })}
            >
              • {Utils.formatMoney(get_total("subtotal"), money_format)}
            </span>
          )} */}
        </button>
        {badges?.isActive && badges.position === "bellow_checkout" && (
          <Badges badges={badges} />
        )}
        {checkout_button.active_continue_shopping_button && (
          <div
            id="mu-continue-shopping"
            onClick={() => {
              if (window.mu_continue_shopping_logic) {
                const continueExecuting = window.mu_continue_shopping_logic();
                if (continueExecuting === false) return;
              }
              if (window.closeCart) window.closeCart();
            }}
            className={classNames(
              "custom-btn w-full w-full py-1 mb-1 text-center cursor-pointer"
            )}
            style={{
              color: Utils.formatColor(
                checkout_button.continue_shopping_button.color
              ),
              fontSize: `${checkout_button.continue_shopping_button.font_size}em`,
              textDecoration:
                checkout_button.active_continue_shopping_underlined &&
                "underline",
            }}
          >
            {checkout_button.continue_shopping_button.text}
          </div>
        )}
        {!!CAN_RENDER_ADD_TO_UNLOCK &&
          add_to_unlock.fbt_position !== "under_products" &&
          add_to_unlock.fbt_position !== "above_checkout" &&
          (add_to_unlock.fbt_position || !add_to_unlock.fbt_below) && (
            <AddToUnlock {...{ add_to_unlock, add_to_unlock_product_id }} />
          )}
      </div>
    );
};

const InfoItem = ({
  name: { text, font_size, color, font_weight },
  value,
  negative = false,
  infoClass = "",
}) => {
  const {
    Utils,
    cart_settings: { money_format },
  } = useContext(CartContext);
  // const original = get_total('discount') > 0 ? get_total('original') : null;
  return (
    <div
      className={classNames(
        `${infoClass} pb-2 flex items-center font-bold info-item`
      )}
      style={{
        fontSize: Utils.em(font_size),
        fontWeight: font_weight,
        color: Utils.formatColor(color),
      }}
    >
      <span
        className={classNames("flex-1 flex-grow")}
        style={{ color: "inherit" }}
      >
        {text}
      </span>
      <AnimatedNumber
        component="span"
        value={value}
        style={{ color: "inherit" }}
        formatValue={(n) =>
          `${
            negative && !window.mu_stop_negative ? "-" : ""
          }${Utils.formatMoney(n, money_format)}`
        }
      />
    </div>
  );
};

const AnimatedNumber = ({ value, style = {}, formatValue = null }) => (
  <span
    {...{ style }}
    data-value={formatValue ? formatValue(value) : value}
    className="notranslate"
    dangerouslySetInnerHTML={{
      __html: formatValue ? formatValue(value) : value,
    }}
  />
);

CheckoutButton.propTypes = {};

export default CheckoutButton;

function ocuHasProduct(
  { one_check_up_sell, multi_one_check_upsell } = {},
  products,
  preview
) {
  if (preview) return true;
  if (!one_check_up_sell && !multi_one_check_upsell) return false;
  return !!products.find(canRenderOCU);
}

export function getAllOCUProducts(campaign) {
  if (!campaign) return [];
  const { one_check_up_sell, multi_one_check_upsell } = campaign;
  return multi_one_check_upsell
    ? multi_one_check_upsell.products
    : [one_check_up_sell];
}

export function isOCUProduct(campaign, product_id, is_example) {
  if (!campaign) return false;
  if (is_example) return true;
  const products = getAllOCUProducts(campaign);
  return !!products.find(
    ({ product }) => product && parseInt(product.id) === product_id
  );
}

function canRenderOCU({ product, text }) {
  return !!product && !!text;
}

// function generateToken (campaigns) {
//   const token = Object.assign(
//     {},
//     ...Object.entries(campaigns).map(([product_id, product_campaigns]: any[]) => {
//       return {
//         [product_id]: product_campaigns.map(({ campaign_key }: any) => campaign_key)
//       }
//     })
//   );
//   const simpleCrypto = new SimpleCrypto('58j?18!rI/]63#i~aqZZ*p(7<GSyJH');
//   return simpleCrypto.encrypt(token)
// }
